<template>
	<h2 :class="{'parent': parent, 'has-completion-type': !!completionType}">
		<span v-if="completionType" :class="['completed-container', completionType]">
			<Icon :icon="completionTypeIcon"/>
		</span>
		<a
			v-if="hasOneAction"
			href="#"
			class="text"
			:title="isTitleTooLong ? title : undefined"
			v-b-tooltip
			@click.prevent="triggerLoneAction"
		>
			{{ preparedTitle }}
		</a>
		<span v-else class="text" :title="isTitleTooLong ? title : undefined" v-b-tooltip>
			{{ preparedTitle }}
		</span>
		<span v-if="tooltip" :title="tooltip" v-b-tooltip.html class="ml-2">
			<Icon icon="info" />
		</span>
		<span v-if="editable" class="edit-container">
			<a href="#" @click.prevent="$emit('edit')">
				<Icon icon="pencil"/>
			</a>
			<a v-if="deletable" href="#" @click.prevent="$emit('delete')">
				<Icon icon="bin"/>
			</a>
		</span>
	</h2>
</template>

<script>
import Icon from "@/vue/icon/Icon";

export const COMPLETION_TYPE__COMPLETED = 'completed';
export const COMPLETION_TYPE__INCOMPLETE = 'incomplete';

const ICON_MAP = {
	[COMPLETION_TYPE__COMPLETED]: 'checkmark',
	[COMPLETION_TYPE__INCOMPLETE]: 'question-mark',
};

const MAX_TITLE_CHARS = 60;

export default {

	components: {
		Icon,
	},

	props: {
		title: {
			type: String,
			required: true
		},
		tooltip: {
			type: String,
			required: false
		},
		completionType: {
			type: String,
			required: false,
		},
		parent: {
			type: Boolean,
			required: false,
			default: false,
		},
		editable: {
			type: Boolean,
			required: false,
			default: true,
		},
		deletable: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	computed: {
		hasOneAction ()
		{
			return (this.editable && !this.deletable) || (this.editable && !this.deletable);
		},
		isTitleTooLong ()
		{
			return this.title.length > MAX_TITLE_CHARS;
		},
		preparedTitle ()
		{
			return this.isTitleTooLong
				? (this.title.substring(0, MAX_TITLE_CHARS) + '...')
				: this.title;
		},
		completionTypeIcon ()
		{
			return ICON_MAP[this.completionType];
		},
	},

	methods: {
		triggerLoneAction ()
		{
			if (this.editable)
			{
				this.$emit('edit');
			}

			if (this.deletable)
			{
				this.$emit('delete');
			}
		}
	}
}
</script>
